import type { AppProps } from 'next/app';

/* CSS */
import { Environment } from '@/config/environment';
import { GoogleTagManager } from '@next/third-parties/google';
import { useEffect, useState } from 'react';
import 'styles/global.css';
import 'styles/hero-mask.css';
import 'styles/print.css';
import useWebvitals from '../hooks/useWebvitals';
import { StyleSheetManager } from 'styled-components';

export default function MyApp({ Component, pageProps }: AppProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const { NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID } = Environment.getBuildtimeEnvVars();
  useWebvitals();
  useEffect(() => {
    setIsLoaded(true);
    console.log('load gtm');
  }, []);
  return (
    <>
      <StyleSheetManager enableVendorPrefixes>
        <Component {...pageProps} />
        {isLoaded && NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID && (
          <GoogleTagManager gtmId={NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID as string} />
        )}
      </StyleSheetManager>
    </>
  );
}
